import { useNavigate } from "react-router-dom";
import GettingStarted from "@/components/GettingStarted";

export default function Guide() {
  const nav = useNavigate();
  return (
    <div className="-m-6">
      <GettingStarted onCta={() => nav("/portfolio")} />
    </div>
  );
}
